module.exports = "<div class=mui-number> <span @click=decrease() :class=\"['mui-number-decrease', {\n    'mui-number-disabled': checkDisabledDecr\n  }]\">-</span> <input number v-model=value class=mui-number-input :style=\"{width: width+'px'}\" pattern=[0-9]* :disabled=disabled :placeholder=placeholder @blur=handlerBlur /> <span @click=increase() :class=\"['mui-number-increase', {\n    'mui-number-disabled': checkDisabledIncr\n  }]\">+</span> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/m-number/index.vue
 ** module id = 168
 ** module chunks = 0
 **/